const getHashToken = (tokenName) => {
  const match = RegExp(`[#&]${tokenName}=([^&]*)`).exec(window.location.hash);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

export default getHashToken;